import * as React from "react";
import {ICurrentStyles} from "shubhform/utils";

interface ISelectFieldProps {
    label: string;
    index: number;
    options: any;
    value: string;
    fieldName: string;
    errorMsg: string;
    onChangeHandler: any;
    disabled?: boolean;
    currentStyles: ICurrentStyles;
}

const InputSelectField: React.FC<ISelectFieldProps> = (props) => {
    const style = props.currentStyles.inputStyle;
    if (props.disabled) {
        style.backgroundColor = "#e7e7e7";
        style.cursor = "not-allowed";
    }
    return (
        <div style={props.currentStyles.containerStyle}>
            <div>{props.label}</div>
            <select
                id={props.fieldName}
                value={props.value ? props.value : "SELECT"}
                style={style}
                onChange={(e) => props.onChangeHandler(props.index, e.target.value)}
                disabled={props.disabled ? props.disabled : false}
            >
                {props.options.map((item, index) => {
                    return (
                        <option value={item.value} key={index}>
                            {item.name}
                        </option>
                    );
                })}
            </select>
            {props.errorMsg && <div style={props.currentStyles.errorStyle}>
                {props.errorMsg}
            </div>}
        </div>
    );
};

export default InputSelectField;
